import * as React from "react";
import { forwardRef } from "react";
const SvgBookmark = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "20-bookmark" }, /* @__PURE__ */ React.createElement("path", { id: "Vector 74", d: "M13 1.99805H7C5.89543 1.99805 5 2.89348 5 3.99805V15.498L10 11.498L15 15.498V3.99805C15 2.89348 14.1046 1.99805 13 1.99805Z", stroke: "currentColor", strokeWidth: 2 })));
const ForwardRef = forwardRef(SvgBookmark);
export default ForwardRef;
